import { useUserAuthentication } from '@ohif/ui';
import { useLocation } from 'react-router';

function hasSharedStudyToken(search: string): boolean {
  const query = new URLSearchParams(search);

  return [...query.keys()].some(key => {
    const lowerCaseKey = key.toLowerCase();
    return lowerCaseKey === 'tk' || lowerCaseKey === 'token';
  });
}

export const PrivateRoute = ({
  children,
  handleUnauthenticated,
  allowSharedStudyToken = false,
}) => {
  const [{ user, enabled }] = useUserAuthentication();
  const location = useLocation();

  if (enabled && !user && !(allowSharedStudyToken && hasSharedStudyToken(location.search))) {
    return handleUnauthenticated();
  }

  return children;
};

export default PrivateRoute;
